import { BlogPostTile } from "@components/content/BlogPostTile"
import { Appear } from "@components/motion/Appear"
import { BlogPostGridTileFragment } from "@generated-types"
import { getTranslation } from "@utils/Translations"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Blog Related",
}

export default defineBlock("section/blog-related", (props) => {
  const regions = props.blog?.headerData?.category?.contentNodes?.nodes || []
  const items = regions
    .filter((n) => "__typename" in n && n.__typename === "Blog" && n.id !== props.blog?.id)
    .slice(0, 3) as BlogPostGridTileFragment[]

  return items.length > 0 ? (
    <div className={cn("blog-related w-full my-9 max-w-blogPostVideoW block-padding mx-auto")}>
      <EditableText
        as="h2"
        store="title"
        placeholder={getTranslation("related", "Related")}
        defaultValue={getTranslation("related", "Related")}
        className="type-header-l mb-6"
      />
      <div className={cn("grid gap-5 grid-cols-1 md:grid-cols-3")}>
        {items.map((item, gx) => (
          <Appear key={item.id} className="w-full" delay={gx * 50}>
            <BlogPostTile item={item} />
          </Appear>
        ))}
      </div>
    </div>
  ) : null
})
